<h1 class="ad-tt">{{ isEdit ? 'Editar domicilio' : 'Agregar un domicilio' }}</h1>
<p class="ad-sub">Lo usamos para las entregas y para avisarte de tu sucursal más cercana.</p>

<div class="mc-blk">

  <div class="ad-fields" *ngIf="!isLoading">

    <div class="ad-f ad-f-ancho">
      <label for="adCalle">Calle</label>
      <input id="adCalle" type="text" name="calle" [(ngModel)]="domicilio.calle"
             placeholder="Nombre de la calle" required>
    </div>

    <div class="ad-f">
      <label for="adNumero">Número</label>
      <input id="adNumero" name="numero" [(ngModel)]="domicilio.numero"
             placeholder="1234" required>
    </div>

    <div class="ad-f">
      <label for="adCp">Código postal</label>
      <input id="adCp" name="codigoPostal" [(ngModel)]="domicilio.codigoPostal" placeholder="1602">
    </div>

    <div class="ad-f">
      <label for="adPiso">Piso <span class="ad-opc">(opcional)</span></label>
      <input id="adPiso" name="piso" [(ngModel)]="domicilio.piso">
    </div>

    <div class="ad-f">
      <label for="adDepto">Departamento <span class="ad-opc">(opcional)</span></label>
      <input id="adDepto" name="departamento" [(ngModel)]="domicilio.departamento">
    </div>

    <div class="ad-f">
      <label>{{ labelProvincia }}</label>
      <select class="ad-select" [formControl]="provinciaControl">
        <option [ngValue]="null" disabled>Elegí {{ esColombia ? 'un departamento' : 'una provincia' }}</option>
        <option *ngFor="let item of provincias" [ngValue]="item">{{ item.name }}</option>
      </select>
    </div>

    <div class="ad-f">
      <label>{{ labelLocalidad }}</label>
      <select class="ad-select" [formControl]="localidadControl">
        <option [ngValue]="null" disabled>Elegí {{ esColombia ? 'un municipio' : 'una localidad' }}</option>
        <option *ngFor="let item of localidades" [ngValue]="item">{{ item.name }}</option>
      </select>
    </div>

    <div class="ad-f">
      <label>Tipo <span class="ad-opc">(opcional)</span></label>
      <select class="ad-select" name="tipo" [(ngModel)]="domicilio.tipo">
        <option [ngValue]="undefined">Sin especificar</option>
        <option value="Casa">Casa</option>
        <option value="Departamento">Departamento</option>
        <option value="Trabajo">Trabajo</option>
      </select>
    </div>

  </div>

  <div class="ad-acts">
    <button class="ad-btn" [disabled]="!domicilio.calle || !domicilio.numero || !localidadControl.valid || !provinciaControl.valid"
            (click)="save()">Guardar cambios</button>
    <button class="ad-lnk" [routerLink]="['/customer-adress-list']">Cancelar</button>
  </div>

</div>

<loading-indicator *ngIf="isLoading"></loading-indicator>
